module.exports = __webpack_public_path__ + "fa34c961d3a88c51098c46375c17146d.jpg";